import React, { useEffect } from "react";
import "./App.css";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import Dashboard from "./Components/Dashboard";
import Login from "./Components/Login";
import ForgotPassword from "./Components/ForgotPassword";
import ChangePassword from "./Components/ChangePassword";
import AddStaff from "./Components/AddStaff";
import ViewStaff from "./Components/ViewStaff";

import ProfileSettings from "./Components/ProfileSettings";

import WebsiteMngt from "./Components/WebsiteMngmt";
import ContactData from "./Components/ContactData";
import AddEvent from "./Components/AddEvent";

function App() {
  useEffect(() => {
    console.log("Effect is running");
    const inputElements = document.getElementsByTagName("input");
    Array.from(inputElements).forEach((input) => {
      input.setAttribute("autocomplete", "off");
    });
  }, [Array]);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />

          <Route path="/Forgot_Password" element={<ForgotPassword />} />
          <Route path="/Change_Password/:id" element={<ChangePassword />} />

          <Route path="/View_Staff" element={<ViewStaff />} />
          <Route path="/Add_Staff" element={<AddStaff />} />
          <Route path="/edit_staff/:id" element={<AddStaff />} />
          <Route path="/ContactData" element={<ContactData />} />

          <Route path="/Profile_Settings" element={<ProfileSettings />} />
          <Route path="/Website_Management" element={<WebsiteMngt />} />
          <Route path="/Add_Event" element={<AddEvent/>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
